/* global videojs */
import {
  Swiper, EffectFade, Navigation, Lazy, Pagination,
} from 'swiper';
import $ from 'jquery';

const swiperContainerClass = '.offer-box__slider';
const swipers = [];
let windowWidth = 0;

function initSwiper($slider) {
  const swiper = new Swiper($slider[0], {
    effect: 'slide',
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
    loop: true,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: '.slider__btn--next',
      prevEl: '.slider__btn--prev',
    },
    pagination: {
      clickable: true,
      el: '.offer-box__pagination',
    },
    modules: [EffectFade, Navigation, Lazy, Pagination],
    on: {
      beforeInit() {
        const numberOfSlides = this.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate )').length;
        if (numberOfSlides <= 1) {
          this.params.loop = false;
        }
      },
    },
  });

  swiper.on('slideChange', (eventData) => {
    const activeSlide = eventData.slides[eventData.activeIndex];
    const videoJS = activeSlide.querySelector('video-js');
    if (!videojs) return;

    if (videoJS) {
      const VideoJsPlayer = window.initLazyVideoJsPlayer
        ? window.initLazyVideoJsPlayer(videoJS)
        : videojs(videoJS);
      VideoJsPlayer.play();
    }
  });

  $slider.find('.swiper-pagination-bullet').each(function (index) {
    const bullet = $(this);
    bullet.attr('id', (index));
  });

  $slider.find('.swiper-pagination').each(() => {
    $slider.find('.swiper-pagination-bullet').attr('tabindex', 0);
    $slider.find('.swiper-pagination-bullet').on('keydown', function (event) {
      if (event.keyCode === '13') {
        const slideID = $(this).attr('id');
        swiper.slideToLoop(slideID);
      }
    });
  });

  swipers.push(swiper);
}

function init() {
  windowWidth = window.screen.width;
  const $boxes = $(swiperContainerClass);
  $boxes.each(function () {
    const $slider = $(this);
    initSwiper($slider);
  });
}

window.addEventListener('resize', () => {
  if (window.screen.width === windowWidth) {
    return;
  }

  swipers.forEach((swiper) => {
    swiper.destroy();
    // eslint-disable-next-line no-param-reassign
    swiper = null;
  });

  init();
});

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=slider', ($block) => {
      initSwiper($block.find(swiperContainerClass));
    });
  } else {
    init();
  }
});
